<template>
  <div id="app" v-cloak>
    <login @showDetail = "change" v-if="showPage == false"></login>
    <modelBox @showDetail = "change" v-else></modelBox>
  </div>
</template>

<script>
import modelBox from '@/pages/modelBox'
import login from '@/pages/login'
export default {
  name: 'app',
  data () {
        return {
            showPage:false
        }
    },
    components:{modelBox,login},
    created(){
        var that = this;
        that.$root.eventHub.$on('backlogin', (val) => {
            that.showPage = val
        });
    },
    methods:{
        change(val){
            this.showPage = val;
        },
        
    }
}
</script>

<style>
 [v-cloak] {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue